import React from 'react';
import { Box, useTheme, Typography } from '@mui/material';
import Header from '../../components/Header';

const HourlyHeader = ({ isSmallScreen, children, selectedMonthYear }) => {
    const theme = useTheme();
    const { year } = selectedMonthYear;

    return (
        <Box
            padding="1rem"
            marginBottom="1rem"
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexDirection={isSmallScreen ? 'column' : 'row'}>
                <Header title="WEEKLY" subtitle="View your weekly count for your devices" />
                <Typography variant="h2" color={theme.palette.text.white} fontWeight="bold" sx={{ alignSelf: isSmallScreen ? 'flex-end' : 'center', mt: isSmallScreen ? 1 : 0 }}>
                    {year}
                </Typography>
            </Box>

            <Box display="flex" flexDirection={isSmallScreen ? 'column' : 'row'} alignItems="center" gap={1}>
                {children}
            </Box>
        </Box>
    );
};

export default HourlyHeader;
